import '.ia{display:inline-block;}.ssr-plugin'
import '.ib{margin-top:1.5rem;}.ssr-plugin'
import '.ao{font-size:0.875rem;}.ssr-plugin'
import '.ic{color:var(--palette-blue-500);}.ssr-plugin'
import '.h7{text-decoration:underline;}.ssr-plugin'
import { useEffect, useMemo, useState } from 'react'
import { useLocation, useSearchParams } from 'wouter'
import { styled } from 'inlines'

export const usePageIndex = () => {
  const [searchParams] = useSearchParams()
  return useMemo(() => {
    const pageRaw = Number(searchParams.get('page'))
    return Number.isFinite(pageRaw) && pageRaw > 0 ? Math.floor(pageRaw) : 1
  }, [searchParams])
}

export type UseDiscoveryCrawlerPageArgs = {
  hasMore: boolean
}

export type UseDiscoveryCrawlerPageResult = {
  nextPageHref: string | null
}

export const buildDiscoveryNextPageHref = (
  location: string,
  searchParams: URLSearchParams,
  nextPage: number,
): string => {
  const next = new URLSearchParams(searchParams.toString())
  next.set('page', String(nextPage))

  if (typeof window !== 'undefined') {
    const url = new URL(location, window.location.origin)
    url.search = next.toString()
    return `${url.pathname}${url.search}`
  }

  const pathOnly = location.split(/[?#]/)[0] ?? location
  return `${pathOnly}?${next.toString()}`
}

export const useDiscoveryCrawlerPage = ({
  hasMore,
}: UseDiscoveryCrawlerPageArgs): UseDiscoveryCrawlerPageResult => {
  const [location] = useLocation()
  const [searchParams] = useSearchParams()
  const page = usePageIndex()

  const nextPageHref = useMemo(() => {
    if (!hasMore) {
      return null
    }

    return buildDiscoveryNextPageHref(location, searchParams, page + 1)
  }, [hasMore, location, page, searchParams])

  return { nextPageHref }
}

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="ia ib ao ic h7"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
